import { Link, useNavigate } from "react-router";
import styled, { css } from "styled-components";

import { confirmUnsavedChanges } from "../../../modules/unsaved-changes";

const CssDeprecated = css`
    color: red;

    &:after {
        content: " DEPRECATED";
    }
`;

const StyledLink = styled(Link)<{ $deprecated?: boolean }>`
    color: #000;
    display: block;
    padding: 3px 10px;
    text-decoration: none;

    &, & * {
        cursor: pointer;
    }

    &:hover {
        background: #000;
        color: #fff;
    }

    ${ ({ $deprecated }) => $deprecated && CssDeprecated };
`;

export default function BimClassCard(props) {
    const { bimClass, guard } = props;
    const navigate = useNavigate();

    async function onClick(event) {
        if (!guard) return;
        event.preventDefault();
        if (await confirmUnsavedChanges(guard)) navigate(bimClass.id);
    }

    return (
        <StyledLink
            $deprecated={ bimClass.metadata.deprecated }
            onClick={ onClick }
            to={ bimClass.id }
        >
            <span>{ bimClass.data.name[0].text }</span>
        </StyledLink>
    );
}
